export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  RESET_PASSWORD: "/resetpassword",
  DRIVER_REGISTRATION: "/driver/registration",
  ACCOUNT: "/account",
  MY_RIDES: "/account/my-ride",
  PROFILE: "/account/profile",
  MONTHLY_SUMMARY: "/account/monthly-summary",
  NEW_RESERVATION: "/account/new-reservation",
  IMPERSONATE: "/member/auto-login",
} as const
